

import __layout_0 from '/builds/51-blocks/bionic-platform/bionic-admin-front/src/layouts/default.vue'
export const layouts = {
'blank': () => import('/builds/51-blocks/bionic-platform/bionic-admin-front/src/layouts/blank.vue'),
'default': __layout_0,
'components/DefaultLayoutWithHorizontalNav': () => import('/builds/51-blocks/bionic-platform/bionic-admin-front/src/layouts/components/DefaultLayoutWithHorizontalNav.vue'),
'components/DefaultLayoutWithVerticalNav': () => import('/builds/51-blocks/bionic-platform/bionic-admin-front/src/layouts/components/DefaultLayoutWithVerticalNav.vue'),
'components/Footer': () => import('/builds/51-blocks/bionic-platform/bionic-admin-front/src/layouts/components/Footer.vue'),
'components/NavBarI18n': () => import('/builds/51-blocks/bionic-platform/bionic-admin-front/src/layouts/components/NavBarI18n.vue'),
'components/NavBarNotifications': () => import('/builds/51-blocks/bionic-platform/bionic-admin-front/src/layouts/components/NavBarNotifications.vue'),
'components/NavbarShortcuts': () => import('/builds/51-blocks/bionic-platform/bionic-admin-front/src/layouts/components/NavbarShortcuts.vue'),
'components/NavbarThemeSwitcher': () => import('/builds/51-blocks/bionic-platform/bionic-admin-front/src/layouts/components/NavbarThemeSwitcher.vue'),
'components/UserProfile': () => import('/builds/51-blocks/bionic-platform/bionic-admin-front/src/layouts/components/UserProfile.vue'),
}

export function setupLayouts(routes) {
  return routes.map(route => {
    return { 
      path: route.path,
      component: layouts[route.meta?.layout || 'default'],
      children: [ {...route, path: ''} ],
    }
  })
}
